/**
 * Event emitter for sudo-related events, similar to atlas implementation
 */

type EventCallback = (data?: any) => void;

export enum SudoEvents {
  ESTABLISHED = "established",
  CANCELLED = "cancelled",
}

class EventEmitter {
  private listeners: Record<string, EventCallback[]> = {};

  subscribe(event: string, callback: EventCallback): () => void {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);

    // Return unsubscribe function
    return () => {
      const index = this.listeners[event]?.indexOf(callback);
      if (index !== undefined && index > -1) {
        this.listeners[event].splice(index, 1);
      }
    };
  }

  emit(event: string, data?: any): void {
    const callbacks = this.listeners[event];
    if (callbacks) {
      callbacks.forEach((callback) => callback(data));
    }
  }

  clear(): void {
    this.listeners = {};
  }
}

export const SudoEventEmitter = new EventEmitter();
